import React from "react"
import { Link } from "gatsby"

export const PrimaryButton = ({ children, className, ...rest }) => {
  return (
    <Link
      {...rest}
      className={`inline-flex items-center justify-center relative z-50 px-5 py-3 text-base font-bold transition-colors duration-100 rounded-md text-primary-dark bg-primary-light hover:bg-secondary-light-2  ${className}`}
    >
      {children}
    </Link>
  )
}

export const SecondaryButton = ({ children, className, ...rest }) => {
  return (
    <Link
      {...rest}
      className={`inline-flex items-center justify-center px-4 py-2 border border-transparent text-xs font-medium transition-colors duration-100 text-primary-dark bg-white rounded-md shadow lg:text-sm group hover:bg-green-50 ${className}`}
    >
      {children}
    </Link>
  )
}
